import { render, staticRenderFns } from "./AppStatusBar.vue?vue&type=template&id=06bcf857&"
import script from "./AppStatusBar.vue?vue&type=script&lang=js&"
export * from "./AppStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./AppStatusBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports